import errorsTranslations from './errorsTranslations';

export const handleApiError = (key: string): string => translateError(key);

const translateError = (key: string): string => errorsTranslations?.[key as keyof typeof errorsTranslations] ?? 'Une erreur est survenue';
